import { memo } from 'react';
import { NumberField as RACNumberField, NumberFieldProps as RACNumberFieldProps } from 'react-aria-components';

import { merge } from '../utils';

export type NumberFieldProps = RACNumberFieldProps;

export const INumberField = ({ className, children, ...rest }: NumberFieldProps) => {
  /* prettier-ignore */
  const styles = [
    'grow',
    'bg-white',
    'outline-none',
    'text-md',
  ];

  /* prettier-ignore */
  const lightStyles = [
    'text-gray-900',
  ];

  return (
    <RACNumberField className={merge(styles, lightStyles, className)} {...rest}>
      {children}
    </RACNumberField>
  );
};

export const NumberField = memo(INumberField) as typeof INumberField;
